import React, { Fragment } from "react"
import {
    Orientation,
    Box,
    HeadingMedium,
} from "@mallardbay/lib-react-components"

import GenericCollection from "~components/shared/collections/generic-collection"
import COPY_CONSTANTS from "~config/copy-constants"
import type { BlogEntryType } from "~utils/blog-helpers"
import { TEST_IDS } from "~config/test-ids"
import {
    ShowMdOrSmaller,
    ShowLgOrLarger,
} from "~components/shared/css-responsive-containers"

import BlogPreview from "./blog-entry-preview"

interface Props {
    readonly blogEntries: BlogEntryType[] | null
    readonly shouldShowBorder?: boolean
}

export default function BlogEntryPreviewList({
    blogEntries,
    shouldShowBorder,
}: Props) {
    if (!blogEntries?.length) return null

    return (
        <Box>
            <ShowLgOrLarger
                data-testid={TEST_IDS.BLOG_ENTRY_PREVIEW_LIST_DESKTOP}
            >
                <HeadingMedium>
                    {COPY_CONSTANTS.RECENT_BLOG_POSTS}
                </HeadingMedium>
                <br />
                <BlogEntryPreviewListVertical
                    blogEntries={blogEntries}
                    shouldShowBorder={shouldShowBorder}
                />
            </ShowLgOrLarger>
            <ShowMdOrSmaller
                data-testid={TEST_IDS.BLOG_ENTRY_PREVIEW_LIST_SLIDER}
            >
                <BlogEntryPreviewSlider blogEntries={blogEntries} />
            </ShowMdOrSmaller>
        </Box>
    )
}

// This is a verticval list of cards.
// The cards can be vertical or horizontal based on the `orientation` pipeline.
export function BlogEntryPreviewListVertical({
    blogEntries,
    shouldShowBorder,
    orientation = Orientation.Vertical,
}: Props & { readonly orientation?: Orientation }) {
    if (!blogEntries?.length) return null

    return (
        <Box>
            {blogEntries.map((otherEntry) => (
                <Fragment key={otherEntry?.id}>
                    <BlogPreview
                        key={otherEntry?.id}
                        blogEntry={otherEntry}
                        orientation={orientation}
                        shouldShowBorder={shouldShowBorder}
                    />
                    <br />
                </Fragment>
            ))}
        </Box>
    )
}

export function BlogEntryPreviewSlider({
    blogEntries,
}: Omit<Props, "shouldShowBorder">) {
    if (!blogEntries?.length) return null

    return (
        <Box>
            <GenericCollection label={COPY_CONSTANTS.RECENT_BLOG_POSTS}>
                {blogEntries.map((blogEntry) => (
                    <BlogPreview
                        key={blogEntry?.id}
                        blogEntry={blogEntry}
                        orientation={Orientation.Vertical}
                        shouldShowBorder
                    />
                ))}
            </GenericCollection>
        </Box>
    )
}
